import React, { useState } from "react";
import DateSelect from "./DateSelect";
import { MillenniumDate } from "@timeedit/millennium-time";
import Language from "../lib/Language";
import _ from "underscore";

// These are just to display a useful range, no need to worry about leap days and the like
const DAYS_PER_YEAR = 365;
const DAYS_TEN_YEARS = 3650;

type TDateRangeValue = {
    startDate: MillenniumDate | null;
    endDate: MillenniumDate | null;
};

type TDateRangeProps = {
    startDate?: MillenniumDate | null;
    endDate?: MillenniumDate | null;
    onChange?: (value: TDateRangeValue) => void;
    hideWeekends?: boolean;
};

const DateRange = (props: TDateRangeProps) => {
    const [range, setRange] = useState<TDateRangeValue>({
        startDate: props.startDate || null,
        endDate: props.endDate || null,
    });

    // The class version notified from a setState callback so it saw the committed
    // state. Building the next value first and passing it straight to onChange is
    // equivalent and avoids needing an effect to observe our own state.
    const select = (key: keyof TDateRangeValue, dates: MillenniumDate[]) => {
        const date = dates.length === 2 ? dates[1] : dates[0];
        const next = { ...range, [key]: date || null };
        setRange(next);
        if (props.onChange) {
            props.onChange(next);
        }
    };

    const today = MillenniumDate.today();
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-evenly",
            }}
        >
            <div>
                <label>{Language.get("cal_reservation_list_column_start_date")}</label>
                <DateSelect
                    onChange={(dates) => select("startDate", dates)}
                    onClose={_.noop}
                    startDate={today.addDays(-DAYS_PER_YEAR)}
                    endDate={today.addDays(DAYS_TEN_YEARS)}
                    now={range.startDate}
                    values={range.startDate ? [range.startDate] : []}
                    hideWeekends={props.hideWeekends || false}
                    showTodayButton={false}
                />
            </div>
            <div>
                <label>{Language.get("cal_reservation_list_column_end_date")}</label>
                <DateSelect
                    onChange={(dates) => select("endDate", dates)}
                    onClose={_.noop}
                    startDate={today.addDays(-DAYS_PER_YEAR)}
                    endDate={today.addDays(DAYS_TEN_YEARS)}
                    now={range.endDate}
                    values={range.endDate ? [range.endDate] : []}
                    hideWeekends={props.hideWeekends || false}
                    showTodayButton={false}
                />
            </div>
        </div>
    );
};

export default DateRange;
